import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import customerSelectImg from "../../../assets/images/customers-select.png";
import "../../../assets/css/style.css";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <h3 className="inc-heading"> End User License Agreement</h3>
          <p>
            PLEASE, READ THIS END USER LICENSE AGREEMENT (“AGREEMENT”) VERY
            CAREFULLY BEFORE CLICKING AN “I AGREE” BUTTON, DOWNLOADING OR USING
            VVDN’S INTELLIGENT NETWORK CONTROLLER IOT AND VIDEO PLATFORM. IF YOU
            DO NOT AGREE TO THIS AGREEMENT, PLEASE DO NOT USE THE SOFTWARE.
            <p style={{ paddingLeft: "2em" }}>
              <strong>WHEREAS</strong>, the Licensor (“VVDN Technologies Private
              Limited”) has developed the Intelligent Network Controller
              Software and is the owner of this Software;
            </p>{" "}
            <p style={{ paddingLeft: "2em" }}>
              <strong>WHEREAS</strong>, the Licensee intends to purchase a
              License and use the Software; and
            </p>{" "}
            <p style={{ paddingLeft: "2em" }}>
              <strong>WHEREAS</strong>, the Licensor is ready to provide such
              the License for usage of the Software under the terms and
              conditions set forth herein, the Parties, in consideration of the
              foregoing premises and realizing reciprocal obligations, contained
              in this Agreement, have agreed as follows:
            </p>{" "}
            <p style={{ paddingLeft: "2em" }}>
              In compliance with the terms and conditions of this End­ User
              License Agreement (hereinafter referred to as the “License
              agreement”/“Agreement”), VVDN Technologies (hereinafter referred
              to as the “Licensor”/“We”) hereby grants Licensee (hereinafter
              referred to as the “Licensee”/“You”) (hereinafter collectively
              referred to as “Parties”) a limited, personal, non-sub licensable,
              non-transferable, royalty-free, nonexclusive right to use the
              Software on the territory only for Licensee’s personal use in
              accordance with any documentation that accompanies the License and
              under the terms set forth herein (hereinafter referred to as the
              “License”). Herewith, under the territory must be understood a
              territory of the whole world. This Agreement cannot be understood
              as an agreement for sale in any way.
            </p>
            <h4 className="inc-blue-heading">General Use Conditions</h4>
            <p style={{ paddingLeft: "2em" }}>
              For the purpose of this Agreement, under the meaning “Software”
              that enables rapid development, management and scaling of IoT and
              Video projects as well as provide a possibility to: (i) provision
              and control devices; (ii) collect and visualize data from devices;
              (iii) analyze device data and trigger alarms; (iv) deliver device
              data to other systems; (v) enable use-case specific features using
              customizable rules and plugins. Using the Software, the Licensee
              is obliged to adhere to the terms and conditions specified herein.
              Before the use of the Software on a fee basis, the Licensee may
              request a demo of the Software under a free trial short term
              License, the period of which is 30 (thirty) days (hereinafter
              referred to as “Test period”). The Licensee can purchase the
              Software License by reaching out to us at
              https://www.vvdntech.com/. For the purpose of this Agreement and
              in accordance with its terms and conditions, the Licensee may use
              the Software on Google Cloud servers on which the Software is
              available. The Software within the current License covers a single
              operating system process. In a case, the Licensee intends to have
              multiple servers or containers with Software installed, each
              server requires purchase of a dedicated license. Upon the Test
              period expiration, the Licensee, on its sole decision, is obliged
              either to fulfill its payment obligations under the new Agreement
              signed at that time or to stop using the Software. The Licensee
              shall strictly comply with all laws, rules, and regulations
              applicable to the use of the Software. The Licensee is entitled to
              use the Software the Licensee paid for, at its sole discretion
              with the purposes that are specified herein as well as with any
              other purposes contemplated by the Software functionality. The
              Licensee is entitled to grant the right on access to the Software
              to its employees, clients and partners or any other individuals
              but only on the basis set forth herein. Herewith, the Licensee is
              obliged not to transfer the Software to the third parties, which
              are not formally authorized by the Licensee to the Software
              access. The Licensee is obliged not to perform any actions
              regarding the Software, which can directly or indirectly breach
              Licensor’s rights and/or contribute the damages for the Licensor
              and/or for the third parties. The Licensee independently bears all
              liability for the consequences that may arise as a result from the
              access to Software provided by the Licensee to its employees,
              clients, partners or other third parties. The Licensee confirms
              that the Software may contain a code, which is able to deactivate
              the Software or suspend the access to the Software after
              termination or early termination of the License.
            </p>
          </p>

          <h4 className="inc-blue-heading">Prohibitions</h4>
          <p style={{ paddingLeft: "2em" }}>
            The Licensee has not any rights to: (i) modify, alter, tamper with,
            repair, or otherwise create derivative works of the Software; (ii)
            reverse engineer, disassemble, or decompile the Software or apply
            any other process or procedure to derive the source code of the
            Software; (iii) access or use the Software in a way intended to
            avoid incurring fees or exceeding usage limits or quotas; (iv)
            resell or sublicense the Software; (v) attempt to disable or
            circumvent any security mechanisms used by the Software; (vi) use
            the Software to perform a malicious activity; or (vii) upload or
            otherwise process any malicious content to or through the Software.
          </p>

          <h4 className="inc-blue-heading">2.Collection</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. You may not access the Service without providing some portion of
            required personal information to us. If you request receipt of
            certain notifications and updates, we will collect personally
            identifiable information, which you voluntarily give us. Said
            information may include your name, telephone number, email address,
            postal address, and any other information which would allow someone
            to personally identify you. Certain non-personally identifiable
            information, or non-PII, may also be collected when you use the
            Service, including the type of the Internet browser and operating
            system you use, region, other navigational clickstream data, etc.
          </p>

          <h4 className="inc-blue-heading">Confidentiality</h4>
          <p style={{ paddingLeft: "2em" }}>
            In the context of this Agreement, the “Confidential Information”
            shall mean an information designated as confidential or reasonably
            considered as confidential, including, but not limited to financial,
            advertising and operational information, information about
            commercial relations between the Licensor and the Licensee. Internal
            structure, constitution and the Software code is valuable commercial
            and confidential information, owned by the Licensor. Each party of
            this Agreement shall keep the other party’s Confidential Information
            confidential by using a reasonable degree of care, but not less than
            the degree of care used to protect its own Confidential Information.
            Each party is obliged not to disclose the other party’s Confidential
            Information to any third party without the other party’s prior
            written consent or except as required by law or use the other
            party’s Confidential Information for any purpose except performing
            this Agreement or furthering the relationship between the Parties.
            The Licensor is entitled to collect, keep and use the Confidential
            information of the Licensee with the purpose of fulfillment of the
            terms of this Agreement as well as for the Software improvement and
            development, if another is agreed by the Parties. The information
            shall not be considered as confidential in case if such information:
            (i) is or becomes publicly known without breaching terms of this
            Agreement or any other similar obligation of confidentiality by the
            Licensee of any other third Party; (ii) was at Licensee’s disposal
            or became known before the moment of signing of this Agreement.
            Within the current Agreement, the Licensee may provide the Licensor
            with both impersonal and personal information about itself with a
            purpose the Licensor to conduct analytical researches in various
            fields regarding the Software development and improvement as well as
            other purposes that could facilitate the Software use in future. In
            this case, such information may be provided by the Licensee only
            based on the Licensee’s consent. For the purpose of this Agreement,
            the “Personal information” means an information or aggregate of
            information about You as an individual, which specifically can
            identify You. This data includes, but is not limited to, your
            surname, name, email address, photo. We make all reasonable steps to
            safeguard and prevent disclosure of your Personal information. We
            try to use all advanced security practices and, whenever possible,
            keep them up to date, but we cannot guarantee that our security and
            security procedures will not contain any errors. We cannot guarantee
            that the transfer of your data will always be safe or that our
            security measures or security measures of our partners cannot be
            affected by the external factors, or that data cannot be damaged by
            the unlawful actions of third parties. In case of the termination or
            early termination of the Agreement, the Licensor is not obligated to
            keep any Licensee’s Confidential information and has a right to
            delete such information at sole discretion after the termination
            date.
          </p>

          <h4 className="inc-blue-heading">
            Intellectual Property Right and Ownership
          </h4>
          <p style={{ paddingLeft: "2em" }}>
            We reserve ownership of all intellectual property rights inherent in
            or relating to the Software, which include, but not limited to, all
            copyright, patent rights, all rights in relation to registered and
            unregistered trademarks (including service marks), confidential
            information (including trade secrets and know-how) and all rights
            other than those expressly granted by this Agreement. These rights
            are reserved by the international treaties and all other applicable
            legislative provisions regarding the intellectual property
            protection. The Software is not sold and is not alienated to the
            Licensee. All rights for the Software are reserved by the Licensor
            except those, which are explicitly transferred to the Licensee as
            the end user of the Software under this Agreement. While using the
            Software, the Licensee is entitled to upload a data which belongs
            the Licensee. Herewith, the Licensee represents and warrants that
            the Licensee owns all rights, title, and interests in and to its
            data and none of its data violates this Agreement, any applicable
            law or any third party’s intellectual property or other right. The
            Licensee acknowledges and confirms that We may use the data, the
            intellectual property rights for which belong to the Licensee, with
            the purpose to improve or develop the Software functionality. We may
            disclose the Licensee’s data to provide the Software to You or to
            comply with any request of a governmental or regulatory body. In a
            case of the termination or early termination of the Agreement, the
            Licensor is not obligated to keep any data the intellectual property
            rights which belong to the Licensee and has a right to delete such
            data at its sole discretion after the termination date.
          </p>

          <h4 className="inc-blue-heading">Term and Termination</h4>
          <p style={{ paddingLeft: "2em" }}>
            Under this Agreement, the License is deemed to be granted to the
            Licensee. The License may be withdrawn, and the Agreement may be
            terminated by the Licensor at any time if the Licensee breaches the
            terms of this Agreement or for other reasons, which may be
            determined by the Licensor as ones that violate the terms of this
            Agreement. The Licensor may terminate this Agreement without
            assigning any reason. In case the License is withdrawn, the
            Agreement is considered to be terminated from the date of
            notification of the Licensee about the withdrawal. Upon this
            Agreement termination, the Licensor agrees to immediately cease the
            Software use including the use of all accompanying documents. Upon
            this Agreement termination all your rights under this Agreement
            immediately are to be terminated.
          </p>

          <h4 className="inc-blue-heading">Warranties Disclaimer</h4>
          <p style={{ paddingLeft: "2em" }}>
            THE LICENSOR PROVIDES THE SOFTWARE “AS IS” AND WITHOUT WARRANTY OF
            ANY KIND, AND HEREBY DISCLAIMS ALL EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING WITHOUT LIMITATION WARRANTIES OF MERCHANTABILITY, FITNESS
            FOR A PARTICULAR PURPOSE, PERFORMANCE, ACCURACY, RELIABILITY, AND
            NON-INFRINGEMENT. WE DO NOT GUARANTEE THAT THE OPERATION OF THE
            SOFTWARE WILL BE UNINTERRUPTED OR ERROR-FREE, AND YOU ACKNOWLEDGE
            THAT IT IS NOT TECHNICALLY PRACTICABLE FOR US TO DO SO. IN NO EVENT
            SHALL THE LICENSOR BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH
            THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. THIS
            DISCLAIMER OF WARRANTY CONSTITUTES AN ESSENTIAL PART OF THIS
            AGREEMENT.
          </p>

          <h4 className="inc-blue-heading">Limitation of Liability</h4>
          <p style={{ paddingLeft: "2em" }}>
            UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY, INCLUDING, BUT NOT
            LIMITED TO, TORT, AGREEMENT, NEGLIGENCE, STRICT LIABILITY, OR
            OTHERWISE, SHALL LICENSOR OR ITS SUPPLIERS OR RESELLERS BE LIABLE TO
            LICENSEE OR ANY OTHER PERSON FOR ANY INDIRECT, SPECIAL, INCIDENTAL,
            OR CONSEQUENTIAL DAMAGES OF ANY CHARACTER INCLUDING, WITHOUT
            LIMITATION, DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL, WORK
            STOPPAGE, ACCURACY OF RESULTS, COMPUTER FAILURE OR MALFUNCTION, OR
            DAMAGES RESULTING FROM YOUR USE OF THE SOFTWARE. LICENSOR’S
            LIABILITY FOR DAMAGES OF ANY KIND WHATSOEVER ARISING OUT OF THIS
            AGREEMENT SHALL BE LIMITED TO THE USD 100 ONLY. THE FOREGOING
            LIMITATIONS SHALL APPLY EVEN IF THE LICENSOR SHALL HAVE BEEN
            INFORMED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
          <h4 className="inc-blue-heading">Liability and Indemnification</h4>
          <p style={{ paddingLeft: "2em" }}>
            If the Licensee violates the Licensor’s intellectual property rights
            and/ or discloses the Licensor’s Confidential information, the
            Licensee is obliged to reimburse to the Licensor all arisen expenses
            and loses. The Licensee independently bears the liability in a case
            of appeals of any third parties, whose rights and/or interests are
            violated in a result of use of the data uploaded by the Licensee
            while using the Software. The Licensee is obliged to indemnify and
            hold harmless the Licensor, its representatives and partners from
            and against any damages, reasonable legal fees and costs finally
            awarded against the Licensor to the extent resulting from or for
            amounts paid by the Licensor to settle any third party claim
            concerning Licensee’s data or the combination of Licensee’s data
            with other applications, content or processes, including any claims
            involving alleged infringement or misappropriation of third-party
            rights by Licensee’s data or by the use, development, design,
            production, advertising or marketing of Licensee’s data. The
            Licensor shall indemnify the Licensee from damages, reasonable legal
            fees, and costs finally awarded against the Licensee in a case when
            a third party asserts against the Licensee a claim that the Software
            infringes a third party’s intellectual property right. In any case,
            the Licensor shall not be obliged to defend or indemnify the
            Licensee if the third parties’ claims are based on any breach of
            this Agreement by the Licensee.
          </p>
          <h4 className="inc-blue-heading">Disputes Resolutions</h4>
          <p style={{ paddingLeft: "2em" }}>
            All issues arising out of or related to this Agreement shall be
            resolved in accordance with the laws of the India. All disputes,
            arising from this Agreement shall be settled by the Parties by
            negotiating. In a case the Parties cannot manage to reach agreement
            on the appropriate dispute, it shall be submitted to the
            corresponding court within the New Delhi, India. Each party hereby
            unconditionally agrees on the exclusive jurisdiction and the place
            of trial venue. Herewith, the Licensee hereby agrees to service of
            process in accordance with the rules of such court.
          </p>
          <h4 className="inc-blue-heading">Support</h4>
          <p style={{ paddingLeft: "2em" }}>
            The Licensor will make all reasonable steps to provide You with a
            quality Software support when it is needed. Herewith, the Licensor
            will provide You a free of charge support with best effort to
            provide 48 hours first response time. The more quality Software
            support could be provided by the Licensor on fee basis if it
            additionally agreed by the Parties.
          </p>
          <h4 className="inc-blue-heading">Miscellaneous</h4>
          <p style={{ paddingLeft: "2em" }}>
            This Agreement represents the complete agreement regarding the
            License that is to be transferred by the Licensor to the Licensee
            and supersedes all prior agreements and representations between
            them. In a case any provision of this Agreement becomes or is
            declared by the court of the competent jurisdiction as illegal,
            unenforceable or void, this Agreement will be effective entirely
            without mentioned provision. After this Agreement is concluded, all
            prior agreements, correspondence, preliminary agreements, protocols
            of intent and any other written or oral appointments between the
            Parties on issues, in some manner regarding this Agreement, lose
            legal effect, but can be taking into consideration in case of
            interpretation of the terms of this Agreement.
          </p>
        </div>
      </div>

      <footer>
        <div className="container">
          Powered by{" "}
          <a
            href="https://www.vvdntech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            VVDN Technologies
          </a>
        </div>
      </footer>
    </>
  );
};

export default PrivacyPolicy;
